/*
  File: assets/ozplug-as-seen-in.js
  Purpose: Mobile-only "As Seen In" marquee cloning. Does not control content visibility.
*/
(function () {
  'use strict';

  if (window.OZPlugAsSeenInReady) return;
  window.OZPlugAsSeenInReady = true;

  var SECTION_SELECTOR = '[data-oz-as-seen]';
  var TRACK_SELECTOR = '[data-oz-as-track]';
  var ITEM_SELECTOR = '[data-oz-as-item]';
  var CLONE_SELECTOR = '[data-oz-as-clone="true"]';
  var MOBILE_QUERY = '(max-width: 720px)';
  var mobileMedia = window.matchMedia ? window.matchMedia(MOBILE_QUERY) : null;
  var resizeTimer = null;

  function isMobile() {
    return mobileMedia ? mobileMedia.matches : window.innerWidth <= 720;
  }

  function removeClones(track) {
    if (!track) return;

    track.querySelectorAll(CLONE_SELECTOR).forEach(function (clone) {
      clone.remove();
    });

    track.removeAttribute('data-oz-as-cloned');
  }

  function createClones(track) {
    if (!track || track.dataset.ozAsCloned === 'true') return;

    var items = Array.prototype.slice.call(track.querySelectorAll(ITEM_SELECTOR)).filter(function (item) {
      return item.getAttribute('data-oz-as-clone') !== 'true';
    });

    if (items.length < 2) return;

    items.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('data-oz-as-clone', 'true');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-oz-as-item');
      track.appendChild(clone);
    });

    track.dataset.ozAsCloned = 'true';
  }

  function syncCarousel(root) {
    if (!root) return;

    var track = root.querySelector(TRACK_SELECTOR);
    if (!track) return;

    root.dataset.ozAsSeenReady = 'true';

    if (isMobile()) {
      createClones(track);
      root.classList.add('is-running');
      return;
    }

    root.classList.remove('is-running');
    removeClones(track);
  }

  function syncAll(context) {
    (context || document).querySelectorAll(SECTION_SELECTOR).forEach(syncCarousel);
  }

  function refreshAll() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      syncAll(document);
    }, 120);
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () { syncAll(document); });

  if (mobileMedia && typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', refreshAll);
  } else if (mobileMedia && typeof mobileMedia.addListener === 'function') {
    mobileMedia.addListener(refreshAll);
  }

  window.addEventListener('resize', refreshAll, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    syncAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    syncAll(event.target);
  });
})();
